export default __webpack_public_path__ + "4cfd91284e27e9468bfaa1da97a91f05.svg";